// Shared rent/property label formatting for LTR room-splitting surfaces.
// Kept as plain functions (not a service) so components can call them during
// precompute without DI — every call site preserves its exact existing string.

// Returns '' when amount is missing (e.g. a room whose pricing hasn't been
// set from listings/leases yet) so callers can compose strings without
// producing a dangling separator or suffix around a blank rent.
export function rentLabel(amount: number | undefined, cadence?: 'weekly' | 'monthly'): string {
  if (!amount) { return ''; }
  const formatted = `$${  amount.toLocaleString('en-US')}`;
  return cadence === 'weekly' ? `${formatted}/wk` : `${formatted}/mo`;
}

// "Palmetto House · Room A" — spaceName is appended only when it differs from
// unit, since room leases/payments already set `unit` to the room label (e.g.
// "Room A"), and whole-unit records have no spaceName at all.
export function propertyLabel(propertyName: string, unit: string, spaceName?: string): string {
  const base = `${propertyName} · ${unit}`;
  return spaceName && spaceName !== unit ? `${base} · ${spaceName}` : base;
}
